import { Accordion, Button, Card, useAccordionButton } from "react-bootstrap";
import { useCancelOffer } from "../../../api/query_hooks/offer";
import Propic from "../../../components/images/propic/Propic";
import { getPropicUrl } from "../../../api/endpoints";

const SentOfferDetails = ({eventKey, offer}) => {

    const cancelMutation = useCancelOffer();

    const cancelOffer = () => {
        cancelMutation.mutate(offer.id);
    };


    return (
        <Card className="bg-darker">
            <Card.Header className="p-0 m-0 border-2 border-black rounded-0">
                <div className="bg-darker hov-bg-1 flex-between col-12 px-3 py-2 border-0 rounded-0" >
                    <p className="m-0">{offer.price} €</p>
                    <p className="m-0">{new Date(offer.createdAt).toLocaleDateString()}</p>
                    <p className="px-1 m-0 text-mini border rounded">{offer.status}</p>
                    <Button variant={offer.status === "PENDING" ? "danger" : "secondary"} type="button" onClick={cancelOffer} disabled={offer.status !== "PENDING"}>
                        Cancel
                    </Button>
                </div>
            </Card.Header>
            <Accordion.Collapse eventKey={eventKey}>
                <Card.Body className="py-2 border-bottom border-2 border-black">
                    <div className="flex-between gap-2">
                        <div className="flex-center flex-grow-1 gap-2 justify-content-start">
                            <Propic className="w-4" src={getPropicUrl(offer.user.propic)} />
                            <div className="d-flex flex-column">
                                <p className="m-0">mail: {offer.user.email}</p>
                                <p className="m-0">website: {offer.user.website}</p>
                            </div>
                        </div>
                        <div className="d-flex gap-2">
                            
                        </div>
                    </div>
                </Card.Body>
            </Accordion.Collapse>
        </Card>
    );
};


export default SentOfferDetails;